import { Phone, Plus, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export const contactList = (s) => String(s || "").split(",").map((x) => x.trim()).filter(Boolean);

export const ContactLinks = ({ value, className = "", iconClass = "h-3.5 w-3.5", prefix = "", testId = "event-contact" }) => (
  <span className={`inline-flex flex-wrap items-center gap-x-3 gap-y-1 ${className}`} data-testid={testId}>
    {prefix && <span>{prefix}</span>}
    {contactList(value).map((n, i) => (
      <a key={i} href={`tel:${n}`} className="inline-flex items-center gap-1 underline-offset-2 hover:underline" data-testid={`${testId}-${i}`}><Phone className={iconClass} />{n}</a>
    ))}
  </span>
);

export const ContactNumbersInput = ({ value, onChange }) => {
  const rows = String(value || "").split(",").map((x) => x.trim());
  const set = (arr) => onChange(arr.map((x) => x.replace(/[^\d+\s-]/g, "").trim()).join(", "));
  return (
    <div className="space-y-2" data-testid="event-contacts">
      {rows.map((n, i) => (
        <div key={i} className="flex gap-2">
          <Input value={n} onChange={(e) => set(rows.map((x, j) => (j === i ? e.target.value : x)))} placeholder="e.g. 9876543210" inputMode="tel" data-testid={i === 0 ? "event-contact-input" : `event-contact-input-${i}`} />
          {rows.length > 1 && <Button type="button" variant="ghost" size="icon" onClick={() => set(rows.filter((_, j) => j !== i))} data-testid={`event-contact-remove-${i}`}><X className="h-4 w-4" /></Button>}
        </div>
      ))}
      {rows.length < 5 && <Button type="button" variant="outline" size="sm" className="gap-1" onClick={() => set([...rows, ""])} data-testid="event-contact-add"><Plus className="h-3.5 w-3.5" /> Add Number</Button>}
    </div>
  );
};
